import { CommonStatusStep } from './service';

export enum UniqueKey {
  ContactUs = 'contact_us',
  // InviteJoin = 'invite_join',
  DownloadCenter = 'download_center',
}

export interface IHistoryValue {
  readonly IsPublic: CommonStatusStep;
  readonly ModifierID: number;
  readonly ModifyTime: Date;
  readonly Status: CommonStatusStep;
  readonly Value: string;
  readonly [index: string]: any;
}

export interface IMailRecord {
  readonly CreateTime: Date;
  readonly CreatorID: number;
  readonly HistoryValue: string | IHistoryValue[];
  readonly IsPublic: CommonStatusStep;
  readonly ModifierID: number;
  readonly ModifyTime: Date;
  readonly Status: CommonStatusStep;
  readonly UniqueKey: UniqueKey;
  readonly Value: string;
  readonly id: number;
}

export interface IAllMailRecord {
  readonly IsPublic: CommonStatusStep;
  readonly Status: CommonStatusStep;
  readonly UniqueKey: UniqueKey;
  readonly Value: string;
  readonly id: number;
}

export interface IRecordMap {
  [key: string]: IMailRecord;
}

export interface IAllRecordMap {
  [key: string]: IAllMailRecord;
}

export interface IRecordBody {
  readonly UniqueKey?: UniqueKey;
  readonly Status: CommonStatusStep;
  readonly IsPublic: CommonStatusStep;
  readonly Value: string;
}
